import { render } from "./RepliManagePortal.vue?vue&type=template&id=7451b880"
import script from "./RepliManagePortal.vue?vue&type=script&lang=js"
export * from "./RepliManagePortal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__